import React, { createContext, useContext, useState, useCallback } from "react";

const DemoContext = createContext(null);

export const DemoProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openDemo = useCallback(() => setOpen(true), []);
  const closeDemo = useCallback(() => setOpen(false), []);
  return (
    <DemoContext.Provider value={{ open, openDemo, closeDemo, setOpen }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error("useDemo must be used within DemoProvider");
  return ctx;
};
